import React from "react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { publicTheme } from "./design/theme";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import Layout from "./components/core/base/Layout";
import { GlobalLoadingProvider } from "./components/core/base/GlobalLoadingContext";
import GlobalLoadingConnector from "./components/core/base/GlobalLoadingConnector";
import Landing from "./Landing";
import Dashboard from "./components/core/Dashboard";
import ClientPortal from "./components/client/ClientPortal";
import Analytics from "./components/core/Analytics";
import ClientsPage from "./components/core/clients/ClientsPage";
import ClientsEditPage from "./components/core/clients/ClientsEditPage";
import ClientDetail from "./components/core/clients/ClientDetail";
import Chat from "./components/core/Chat";
import MessengerPage from "./components/MessengerPage";
import TestSnackbar from "./components/core/TestSnackbar";
import ContactManager from "./components/core/ContactManager";
import RegisterAdmin from "./components/core/admin/RegisterAdmin";
import AdminPanel from "./components/core/admin/AdminPanel";
import LoginAdmin from "./components/core/admin/LoginAdmin";
import BusinessSettings from "./components/core/admin/BusinessSettings";
import RegisterFounder from "./components/core/founder/RegisterFounder";
import Login from "./components/core/founder/Login";
import Profile from "./components/core/founder/Profile";
import SubscriptionExpired from "./components/SubscriptionExpired";
import Settings from "./components/core/settings/Settings";
import { ThemeProvider } from "./components/core/context/ThemeContext";
import StaffPage from "./components/core/staff/StaffPage";
import StaffProfilePage from "./components/core/staff/StaffProfilePage";
import StaffEditPage from "./components/core/staff/StaffEditPage";
import AssetsPage from "./components/business_types/rental/assets/AssetsPage";
import CourierPage from "./components/business_types/rental/courier/CourierPage";
import CourierApp from "./components/courier/CourierApp";
import AssetsEditPage from "./components/business_types/rental/assets/AssetsEditPage";
import ShowcasePage from "./components/business_types/rental/showcase/ShowcasePage";
import StorefrontPage from "./components/storefront/StorefrontPage";
import AndroidDownloadPage from "./components/AndroidDownloadPage";
import FaqPage from "./components/FaqPage";
import AssetHistoryPage from "./components/business_types/rental/history/AssetHistoryPage";
import RentalDealsPage from "./components/business_types/rental/deals/RentalDealsPage";
import RentalDealsEditPage from "./components/business_types/rental/deals/RentalDealsEditPageFixed";
import ReturnsPage from "./components/business_types/rental/deals/ReturnsPage";
import AvitoOrdersPage from "./components/business_types/rental/deals/AvitoOrdersPage";
import ApplicationsPage from "./components/core/ApplicationsPage";
import Expenses from "./components/core/Expenses";
import Sales from "./components/core/Sales";
import Reports from "./components/core/Reports";
import ProcurementPage from "./components/core/ProcurementPage";
import ClientReportsPage from "./components/reports/ClientReportsPage";
import FinancialReportsPage from "./components/reports/FinancialReportsPage";
import AssetReportsPage from "./components/reports/AssetReportsPage";
import UnauthorizedPage from "./components/core/auth/UnauthorizedPage";
import ProtectedRoute from "./components/core/auth/ProtectedRoute";
import NotFoundPage from "./components/core/errors/NotFoundPage";
import LegalDocsPage from "./components/LegalDocsPage";
import PaymentReturnPage from "./components/PaymentReturnPage";

const PublicUI = ({ children }) => <MuiThemeProvider theme={publicTheme}>{children}</MuiThemeProvider>;

function App() {
  return (
    <SnackbarProvider maxSnack={3}>
      <GlobalLoadingProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <GlobalLoadingConnector />
          <ThemeProvider>
            <Routes>
              {/* Страницы ВНЕ Layout - полностью независимые от CRM */}
              <Route path="/" element={<PublicUI><StorefrontPage /></PublicUI>} />
              <Route path="/app" element={<PublicUI><AndroidDownloadPage /></PublicUI>} />
              <Route path="/faq" element={<PublicUI><FaqPage /></PublicUI>} />
              <Route path="/help" element={<PublicUI><FaqPage /></PublicUI>} />
              <Route path="/help/:slug" element={<PublicUI><FaqPage /></PublicUI>} />
              <Route path="/courier-app/*" element={<PublicUI><CourierApp /></PublicUI>} />
              <Route path="/crm-info" element={<PublicUI><Landing /></PublicUI>} />
              <Route path="/login" element={<Login />} />
              <Route path="/register-founder" element={<RegisterFounder />} />
              <Route path="/login-admin" element={<LoginAdmin />} />
              <Route path="/register-admin" element={<RegisterAdmin />} />
              <Route
                path="/subscription-expired"
                element={<SubscriptionExpired />}
              />
              <Route path="/unauthorized" element={<UnauthorizedPage />} />
              {/* Юридические документы - публичный доступ */}
              <Route path="/docs/terms" element={<PublicUI><LegalDocsPage doc="terms" /></PublicUI>} />
              <Route path="/docs/license" element={<Navigate to="/docs/terms" replace />} />
              <Route path="/docs/offer" element={<PublicUI><LegalDocsPage doc="offer" /></PublicUI>} />
              <Route path="/docs/consent" element={<PublicUI><LegalDocsPage doc="consent" /></PublicUI>} />
              <Route path="/docs/refunds" element={<PublicUI><LegalDocsPage doc="refunds" /></PublicUI>} />
              <Route path="/docs/cookies" element={<PublicUI><LegalDocsPage doc="cookies" /></PublicUI>} />
              <Route path="/docs/deletion" element={<PublicUI><LegalDocsPage doc="deletion" /></PublicUI>} />
              <Route path="/docs/contacts" element={<PublicUI><LegalDocsPage doc="contacts" /></PublicUI>} />
              <Route path="/docs/privacy" element={<PublicUI><LegalDocsPage doc="privacy" /></PublicUI>} />
              {/* Личный кабинет клиента - публичный доступ */}
              <Route path="/my" element={<PublicUI><ClientPortal /></PublicUI>} />
              <Route path="/payment/success" element={<PublicUI><PaymentReturnPage /></PublicUI>} />
              <Route path="/payment/failure" element={<PublicUI><PaymentReturnPage failed /></PublicUI>} />
              <Route path="/returns" element={<ProtectedRoute><Layout><ReturnsPage /></Layout></ProtectedRoute>} />
              <Route path="/my/:token" element={<PublicUI><ClientPortal /></PublicUI>} />
              <Route path="/me" element={<PublicUI><ClientPortal /></PublicUI>} />{" "}
              {/* Алиас для Telegram */}
              {/* Публичная витрина-магазин (алиас на главную) */}
              <Route path="/shop" element={<PublicUI><StorefrontPage /></PublicUI>} />
              {/* Все остальные страницы ВНУТРИ Layout CRM - защищены авторизацией */}
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Dashboard />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/applications"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ApplicationsPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/analytics"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Analytics />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/deals"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Sales />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reports"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Reports />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reports/clients"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ClientReportsPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reports/financial"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <FinancialReportsPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reports/assets"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <AssetReportsPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/expenses"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Expenses />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/procurement"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ProcurementPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/messenger"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <MessengerPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/clients"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ClientsPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/clients/edit/:id"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ClientsEditPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/clients/view/:id"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ClientDetail />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/chat/:id"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Chat />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/test-snackbar"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <TestSnackbar />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/contact-manager"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ContactManager />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin-panel"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <AdminPanel />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Profile />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Settings />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/staff/"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <StaffPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/staff/:id"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <StaffProfilePage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/staff/edit/:id"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <StaffEditPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/assets"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <AssetsPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/courier"
                element={
                  <ProtectedRoute>
                    <Layout><CourierPage /></Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/showcase"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ShowcasePage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/assets/edit/:id"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <AssetsEditPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/assets/:assetId/history"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <AssetHistoryPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/rental-deals"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <RentalDealsPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/rental-deals/edit/:id"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <RentalDealsEditPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/avito-orders"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <AvitoOrdersPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/business/:id"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <BusinessSettings />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              {/* Catch-all маршрут для всех несуществующих страниц - должен быть последним */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </ThemeProvider>
        </Router>
      </GlobalLoadingProvider>
    </SnackbarProvider>
  );
}

export default App;
